// extracted by mini-css-extract-plugin
export var btnFull = "ctaVideoButton-module--btnFull--8a296";
export var button = "ctaVideoButton-module--button--d09aa";
export var container = "ctaVideoButton-module--container--41d9e";
export var link = "ctaVideoButton-module--link--255c0";
export var playIcon = "ctaVideoButton-module--playIcon--b17e7";
export var text = "ctaVideoButton-module--text--66feb";
export var textUnderline = "ctaVideoButton-module--textUnderline--7cfa2";